/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import Mitteilung from "../Queries/Mitteilung";
import MitteilungVersion from "./MitteilungVersion";

export default class MitteilungVersionUtil {
    public static mitteilungenZuMitteilungVersionen(mitteilungen: Mitteilung[]): MitteilungVersion[] {
        return mitteilungen.map(mitteilung => ({
            mitteilungId: mitteilung.mitteilungId,
            geaendert: mitteilung.geaendert
        }));
    }
}